import { gql } from '@apollo/client';
import React, { useState, useMemo } from 'react';
import { useAddToBag, ADD_TO_BAG_FRAGMENT } from '../../../../../hooks/useAddToBag';
import { VariantCellSizeSlider, VARIANT_CELL_SIZE_SLIDER_FRAGMENT } from '../VariantCellSizeSlider';
import { VariantCellQuickAddFragment } from '../../../../../generated/types/VariantCellQuickAddFragment';
import { compact } from '../../../../../lib/compact';
import { getActiveVariantBy } from '../../../../../lib/getActiveVariantBy';

import './VariantCellQuickAdd.scss';

export const VARIANT_CELL_QUICK_ADD_FRAGMENT = gql`
  fragment VariantCellQuickAddFragment on Variant {
    ...VariantCellSizeSliderFragment
    ...AddToBagFragment
  }
  ${VARIANT_CELL_SIZE_SLIDER_FRAGMENT}
  ${ADD_TO_BAG_FRAGMENT}
`;

type Props = {
  variant: VariantCellQuickAddFragment;
  activeVariantId: string;
  position?: number;
  href: string;
};

export const VariantCellQuickAdd: React.FC<Props> = ({
  variant,
  activeVariantId,
  position = 1,
  href
}) => {
  const [selectedSize, setSelectedSize] = useState<string | undefined>(undefined);

  const activeVariant = useMemo(() => getActiveVariantBy(variant, 'id', activeVariantId), [
    activeVariantId,
    variant
  ]);

  const selectedInventory = useMemo(
    () => compact(activeVariant.inventory).find(({ size }) => size === selectedSize),
    [activeVariant.inventory, selectedSize]
  );

  const { text, handleAddToBag } = useAddToBag({
    activeVariantId,
    variant,
    position,
    size: selectedInventory,
    href,
    validatesSizePresenceOn: 'always'
  });

  return (
    <div className="VariantCellQuickAdd">
      <h4 className="VariantCellQuickAdd__title">{text}</h4>

      <VariantCellSizeSlider
        variant={variant}
        activeVariantId={activeVariantId}
        onSelectSize={setSelectedSize}
        onClick={handleAddToBag}
      />
    </div>
  );
};
